import {Input, Label, SearchField, Text} from 'react-aria-components'
import styled from 'styled-components'
import {CrossButton} from '../button/cross-button/cross-button'
import {spacing} from '../../theme/spacing'
import {mediumSmallFont, smallFont} from '../../theme/font-styles'
import {DefaultBorderCss, FocusBorderCss} from '../base/base.styled'
import {VesselSelectorTree} from './vessel-selector-tree'

const Styled = {
    SearchField: styled(SearchField)`
        display: grid;
        grid-template-areas:
            'label label'
            'input button'
            'help help';
        grid-template-columns: 1fr auto;
        align-items: center;
        padding-bottom: ${spacing(1.5)};
        border-bottom: 1px solid ${({theme}) => theme.colors.border.default};

        &[data-empty] button {
            display: none;
        }

        &[data-disabled] {
            opacity: 0.5;
            pointer-events: none;
        }
    `,
    Label: styled(Label)`
        grid-area: label;
        ${mediumSmallFont()}
    `,
    Input: styled(Input)`
        grid-area: input;
        outline: none;
        padding: ${spacing(1)} ${spacing(4)} ${spacing(1)} ${spacing(1)};
        background: ${({theme}) => theme.colors.background.default};
        color: ${({theme}) => theme.colors.text.default};
        ${DefaultBorderCss}

        &::-webkit-search-cancel-button,
        &::-webkit-search-decoration {
            -webkit-appearance: none;
        }

        &::placeholder {
            opacity: 1;
            color: ${({theme}) => theme.colors.text.default};
        }

        &[data-focused] {
            ${FocusBorderCss}
        }
    `,
    CrossButton: styled(CrossButton)`
        grid-area: button;
        margin-left: -${spacing(6)};
    `,
    Text: styled(Text)`
        grid-area: help;
        ${smallFont()}
    `,
    VesselSelectorTree: styled(VesselSelectorTree)`
        overflow-y: auto;
    `,
}

export default Styled
